const _ = require('lodash');

const Place = require('./place'); // Current required properties for an address:

/*
osm_uid
google_place_id

suite
building
street_address
street
postalcode

locality
neighbourhood
city
county
state
region
country

centre
area

timezone
 */


const buildLabel = address => _([_([address.suite ? `#${address.suite}` : '', address.streetAddress, address.street]).compact().join(' '), address.city, address.state, address.country]).compact().join(', ');

class Address extends Place {
  constructor(args
  /*: PlaceInitObject*/
  ) {
    super(args);
    this.label = buildLabel(this);
  }

}

Address.fromJson = json => new Address(Address.jsonToInitObj(json));

module.exports = Address;